import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
} from 'react';
import { FormTemplate, FormTemplateSection } from 'data/template/template.types';
import * as types from 'data/periodicAudit/periodicAudit.types';
import Form, {
  FieldUpdateHandlerParam,
} from 'shared/form';
import './periodic-audit-form.scss';
import { FormLayout } from 'components/FormLayout';
import SectionLabel from 'components/SectionLabel';

type Props = {
  template: FormTemplate,
  data: Partial<types.PeriodicAudit>
  i18nKeyPrefix?: string
  isEditing?: boolean,
  onFieldUpdate?: (param: FieldUpdateHandlerParam, formSection?: 'main') => void
}

export type Ref = {
  isValid: (forceValidation: boolean, forceTouched: boolean) => boolean
  getValues: () => types.PeriodicAudit
}

export const COLLECTION_FUNCTION_GROUP_I18N_KEY = 'periodicAFAudit.form';

export const PeriodicAuditForm = forwardRef<Ref, Props>(({
  template,
  data,
  i18nKeyPrefix = COLLECTION_FUNCTION_GROUP_I18N_KEY,
  onFieldUpdate = () => null,
}: Props, ref) => {
  const mainRef = useRef<Form>(null);

  const customFieldComponentMap = {
    schedule: SectionLabel,
  };
  const isValid = (forceValidation = false, forceTouched = true) => {
    const isMainValid = mainRef.current?.isValid(forceValidation, forceTouched) ?? true;
    return isMainValid;
  };

  const getValues = () => {
    const formValues: types.PeriodicAudit = {
      ...mainRef.current?.getValues(),
    };

    return formValues;
  };

  useImperativeHandle(ref, () => ({
    isValid,
    getValues,
  }));

  const onMainFieldUpdate = (param: FieldUpdateHandlerParam) => onFieldUpdate(param, 'main');

  return (
    <div className="utimaco-packet-switch-form" data-testid="UtimacoPacketSwitchForm">
      <div data-testid="UtimacoPacketSwitchFormMain">
        <FormLayout>
          <Form
            ref={mainRef}
            name={template.formId ?? template.key}
            defaults={data}
            fields={(template.main as FormTemplateSection).fields}
            layout={(template.main as FormTemplateSection).metadata.layout?.rows}
            i18nKeyPrefix={i18nKeyPrefix}
            fieldUpdateHandler={onMainFieldUpdate}
            customFieldComponentMap={customFieldComponentMap}
          />
        </FormLayout>
      </div>
    </div>
  );
});

export default PeriodicAuditForm;
